import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function FuelIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M22.314 2.30371L19.7461 4.90918C19.272 5.39258 19 6.06543 19 6.75586V12.9824C19 14.1846 18.103 15.1631 17 15.1631C15.897 15.1631 15 14.1846 15 12.9824V0.980469H2V20.9805H0V22.9805H18V20.9805H15V16.5817C15.5908 16.9417 16.2682 17.1631 17 17.1631C19.2056 17.1631 21 15.2881 21 12.9824V6.75586C21 6.58496 21.0635 6.42188 21.1724 6.31152L23.7388 3.708L22.314 2.3037L22.314 2.30371ZM13 2.98047V7.98047H4V2.98047H13ZM4 20.9805V9.98047H13V20.9805H4ZM6 12.9805H11V14.9805H6V12.9805Z",
    fill: "currentColor"
  }));
}